module.exports = __webpack_public_path__ + "static/media/18ECA19.1dd3c85b.jpg";